export default function Footer() {
    return (
        <footer className="bg-gray-800 text-white py-8">
            <div className="container mx-auto px-4 text-center">
                <p>© {new Date().getFullYear()} Inspira Cambio. Todos los derechos reservados.</p>
                <div className="mt-4 flex justify-center space-x-4">
                    <a href="/terminos" className="hover:underline">Términos y Condiciones</a>
                    <a href="/privacidad" className="hover:underline">Aviso de Privacidad</a>
                    <a href="/contacto" className="hover:underline">Contacto</a>
                </div>
            </div>
        </footer>
    );
}